import React, { Component } from "react";
import {
  NormalButton,
  NormalSelect,
  NormalCheckbox,
  NormalInput,
  NormalModal,
  NormalTextarea,
  InputSearch,
  NormalTable,
  NormalButtonBackend,
} from "component/common";
import { withTranslation } from "react-i18next";
import "./style.scss";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  getBackendCommonApi,
  ItemSitelists,
  updateCommon,
} from "redux/actions/Backend";
import {
  commonCreateApi,
  commonUpdateApi,
  getCommonApi,
} from "redux/actions/common";
import { Toast } from "service/toast";

export class MGMPolicyClass extends Component {
  constructor(props) {
    super(props);
    this.state = {
      levels: [
        { id: 1, value: 100, active: true },
        { id: 2, value: 0, active: false },
        { id: 3, value: 0, active: false },
      ],
      mode: "one-time",
      policyId: null,
    };
  }

  componentDidMount = () => {
    this.fetchData();
  };

  handleValueChange = (id, value) => {
    this.setState((prevState) => ({
      levels: prevState.levels.map((level) =>
        level.id === id ? { ...level, value: parseInt(value) || 0 } : level
      ),
    }));
  };

  handleActiveChange = (id) => {
    this.setState((prevState) => ({
      levels: prevState.levels.map((level) =>
        level.id === id ? { ...level, active: !level.active } : level
      ),
    }));
  };

  handleModeChange = (mode) => {
    this.setState({ mode });
  };

  fetchData = async () => {
    this.props.getBackendCommonApi("MgmPolicies").then((data) => {
      console.log(data, "Response");
      if (data[0]) {
        this.setState({
          levels: [
            {
              id: 1,
              value: data[0]?.Level1 || 0,
              active: data[0]?.level1IsActive || false,
            },
            {
              id: 2,
              value: data[0]?.Level2 || 0,
              active: data[0]?.level2IsActive || false,
            },
            {
              id: 3,
              value: data[0]?.Level3 || 0,
              active: data[0]?.level3IsActive || false,
            },
          ],
          mode: data[0]?.policyStatus === 0 ? "one-time" : "always",
          policyId: data[0]?.id,
        });
      }
    });
  };
  handleAdd = () => {
    const { levels, policyId, mode } = this.state;
    const mgmDate = new Date()?.toISOString()?.split("T")[0];
    console.log(levels, "levels");
    const loggedin_Id = this.props.tokenDetails?.login_id;
    const payload = {
      Level1: levels[0].value,
      Level2: levels[1].value,
      Level3: levels[2].value,
      userID: loggedin_Id?.toString(),
      policyStatus: mode === "one-time" ? 0 : 1,
      mgmDate: mgmDate,
      level1IsActive: levels[0].active,
      level2IsActive: levels[1].active,
      level3IsActive: levels[2].active,
    };

    if (policyId) {
      this.props
        .updateCommon(
          `MgmPolicies/update?where=%7B%22id%22%3A%20${policyId}%7D`,
          payload
        )
        .then((res) => {
          this.fetchData();
        });
    } else {
      this.props.updateCommon(`MgmPolicies/`, payload).then((res) => {
        this.fetchData();
      });
    }

    console.log(payload);
  };

  render() {
    const { levels, mode } = this.state;

    return (
      <div className="mgm-policy">
        <div className="mgm-policy__header">
          <h4 className="mgm-policy__title">MGM Policy</h4>
        </div>

        <div className="mgm-policy__content">
          <div className="mgm-policy__mode">
            <label className="mgm-policy__radio">
              <input
                type="radio"
                name="mode"
                checked={mode === "one-time"}
                onChange={() => this.handleModeChange("one-time")}
              />
              <span>one time</span>
            </label>
            <label className="mgm-policy__radio">
              <input
                type="radio"
                name="mode"
                checked={mode === "always"}
                onChange={() => this.handleModeChange("always")}
              />
              <span>always</span>
            </label>
          </div>
          <div className="mgm-policy__levels">
            {levels.map((level) => (
              <div key={level.id} className="mgm-level">
                <label className="mgm-level__label">
                  MGM Level {level.id}:
                </label>
                <input
                  type="number"
                  className="mgm-level__input"
                  value={level.value}
                  onChange={(e) =>
                    this.handleValueChange(level.id, e.target.value)
                  }
                />
                <span className="mgm-level__percent">%</span>
                <label className="mgm-level__checkbox">
                  <input
                    type="checkbox"
                    checked={level.active}
                    onChange={() => this.handleActiveChange(level.id)}
                  />
                  <span>Active</span>
                </label>
              </div>
            ))}
          </div>

          <button className="mgm-policy__add-btn mt-3" onClick={this.handleAdd}>
            Save
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  tokenDetails: state.authStore.tokenDetails,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      ItemSitelists,
      commonCreateApi,
      getCommonApi,
      commonUpdateApi,
      getBackendCommonApi,
      updateCommon,
    },
    dispatch
  );
};

export const MGMPolicy = withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(MGMPolicyClass)
);
